module.exports = __webpack_public_path__ + "static/media/logo.f4dabc12.png";